import './Rex.scss';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import {getCurrentUser} from '../../stores/actions/user';
import {getCurrentUserDetails, resetUserDetails} from '../../stores/actions/userDetails';
import {getRexGifts, orderGifts, resetErrors, resetGifts} from '../../stores/actions/rex';
import {getMainProduct, resetMainProduct} from '../../stores/actions/omaviihde';

import * as PL from 'react-patterns';
/*
   Using local version until 'disabled' bug is fixed in react-patterns
   const Button = PL.button.BasicButton;
*/
import {BasicButton as Button} from '../react-patterns/Button';

import MarketingBlock from '../react-patterns/MarketingBlock';

import GiftChooser from './GiftChooser';
import DeviceChooser from "./DeviceChooser";
import Blurb from './Blurb';
import Summary, {priceToFloat} from './Summary';
import Form from './Form';
import Thanks from './Thanks';
import {ScrollToTop} from "../ScrollToTop";

const Ingress = PL.typography.textblock.Ingress;
const H1 = PL.typography.header.H1;
const H2 = PL.typography.header.H2;

const errorMessages = {
  'NOT_ELIGIBLE': <div>
    Sinulla on voimassa oleva määräaikainen sopimus.<br/>
    Määräaikaisen sopimuksen voi uusia, kun sopimuksen päättymiseen on vähemmän kuin kolme kuukautta.
    Voit tarkistaa määräaikaisen sopimuksesi päättymispäivän
    &nbsp;<a href="https://verkkoasiointi.elisa.fi/sopimukset">OmaElisasta</a>.
  </div>,
  'CONTRACT_NOT_FOUND': 'Sinulla ei ole määräaikaista Elisa Viihde -sopimusta.',
  'WRONG_PIN': <div><strong>Virheellinen PIN-koodi.</strong><br/>Voit tarkistaa PIN-koodisi osoitteesta omaelisa.fi</div>,
  'UNKNOWN': 'Palvelin- tai verkkovirhe. Yritä hetken kuluttua uudestaan.'
};
/* HELPER COMPONENTS */

const Banner = () => <img className="rx-banner" src="/img/rex/marketing.png"/>;

const NotLoggedIn = () => (
  <div>
    <H1>Hyödynnä hyvän asiakkaan etusi</H1>
    <Ingress>
      Kirjaudu sivustolle oikeasta yläkulmasta Elisa Viihde -tunnuksillasi.
      Elisa Viihde -tunnukset löydät tilausvahvistuksesta tai OmaElisasta.
      Voit myös kirjautua mobiilivarmenteella. Kun olet kirjautunut,
      pääset uusimaan sopimuksesi ja tilaamaan lahjasi.
    </Ingress>
  </div>);

const NoContract = () => <H2>Sinulla ei ole määräaikaista Elisa Viihde -sopimusta.</H2>;

const NotEligible = () => (
  <div>
    <H2>Sinulla on voimassa oleva määräaikainen sopimus</H2>
    <Ingress>
      Määräaikaisen sopimuksen voi uusia, kun sopimuksen päättymiseen on vähemmän kuin kolme kuukautta.
      Voit tarkistaa määräaikaisen sopimuksesi päättymispäivän
      &nbsp;<a href="https://verkkoasiointi.elisa.fi/sopimukset">OmaElisasta</a>.
    </Ingress>
  </div>);

/* MAIN COMPONENT */

class Rex extends Component {
  static propTypes = {
    user: PropTypes.object,
    userDetails: PropTypes.object,
    gifts: PropTypes.object,
    submitData: PropTypes.object,
    apiError: PropTypes.string,
    mainProduct: PropTypes.object,
    form: PropTypes.object,
    updateForm: PropTypes.any,
    getCurrentUser: PropTypes.func,
    orderGifts: PropTypes.func,
    resetErrors: PropTypes.func,
    getUserData: PropTypes.func,
    resetUserData: PropTypes.func
  };

  static initialState = {
    page: 'main',
    selectedGift: null,
    showUnderCounterGifts: true,
    delivery: 'email',
    otherEmail: '',
    pinCode: '',
    pinCodeEntered: false,
    isLoading: false,
    apiError: '',
    errorMessage: ''
  };

  constructor(props) {
    super(props);

    this.state = Rex.initialState;
  }

  componentDidMount() {
    this.props.getCurrentUser();
    document.addEventListener('keydown', e => this.toggleUnderCounterGifts(e));
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.toggleUnderCounterGifts);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(newProps) {
    // have to check username instead of isLoggedIn for impersonation
    // (sort of logs in twice in a row without logging out first)
    if (this.props.user.username !== newProps.user.username)
    {
      this.setState({ ...Rex.initialState });
      this.props.resetErrors();
      this.props.resetUserData();

      if (newProps.user.username) {
        // user logged in
        this.props.getUserData(newProps.user);
      } else {
        // user logged out
      }
    }

    // Submit succeeded, show thank you page
    if (!_.isEmpty(newProps.submitData)) {
      this.setState({ isLoading: false, page: 'thanks' });
    }

    // POST API error handling
    if (newProps.apiError) {
      let apiError = newProps.apiError;

      if (!(apiError in errorMessages)) {
        apiError = 'UNKNOWN';
      }

      this.setState({
        isLoading: false,
        apiError,
        errorMessage: errorMessages[apiError]
      });

      if (apiError === 'WRONG_PIN') {
        this.setState({
          pinCode: '',
          pinCodeEntered: false
        });
      }

      this.props.resetErrors();
    }
  }

  toggleUnderCounterGifts(e) {
    if (e.keyCode === 27 || e.keyCode === 120) {
      this.setState({ showUnderCounterGifts: !this.state.showUnderCounterGifts });
    }
  }

  updateForm = (data) => {
    if (data.pinCode) {
      if (data.pinCode.length === 4) {
        this.setState({ pinCodeEntered: true });
      } else {
        this.setState({ pinCodeEntered: false });
      }
    }
    if (data.selectedGift) {
      this.setState({ isDeviceRequiredForGift: this.deviceRequired(data.selectedGift) });
    }
    this.setState(data);
  };

  deviceRequired = (selectedGift) => {
    const allFetched =
      this.props.gifts.isFetched &&
      this.props.userDetails.isFetched &&
      this.props.mainProduct.isFetched;
    if (!allFetched) {
      return false;
    }
    const devices = this.getUser().devices;
    if (devices && devices.length === 1) {
      return false;
    }
    const gifts = this.props.gifts.gifts;
    const giftDetails = _.find(gifts, { productId: selectedGift });
    const products = this.getUser().products;
    if (!products) {
      return false;
    }
    const selectedGiftParentProduct = _.find(products, { productId: giftDetails.parentProductId });
    return selectedGiftParentProduct && selectedGiftParentProduct.requiresPlatformSelection;
  };

  confirmForm = (e) => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      const user = this.getUser();

      const deliveryMethod = this.state.delivery === 'post' ? 'post' : 'email';
      const email = this.state.delivery === 'otherEmail' ?
        this.state.otherEmail : user.email;

      const viihdeCampaignOrder = {
        campaignProductId: this.state.selectedGift,
        orderConfirmationMethod: deliveryMethod,
        email,
        address: user.fullAddress
      };

      if (this.state.isDeviceRequiredForGift) {
        viihdeCampaignOrder.userDeviceId = this.state.selectedDeviceId;
      }

      const payload = {
        pinCode: this.state.pinCode,
        viihdeCampaignOrder
      };

      this.props.orderGifts(payload);
    }

    e.preventDefault();
    e.stopPropagation();
  };

  getUser() {
    const user = { ...this.props.user, ...this.props.userDetails };

    // if prop in userDetails is empty, don't override user object
    for (const key in this.props.userDetails) {
      if (this.props.user[key] && !this.props.userDetails[key]) {
        user[key] = this.props.user[key];
      }
    }

    if (user.elisaIdImpersonatorId) {
      user.isImpersonated = true;
    }

    if (user.address && user.address.street) {
      user.fullAddress =
        user.address.street + ', ' +
        user.address.zipCode + ' ' +
        user.address.city;
    } else {
      user.fullAddress = '';
    }

    return user;
  }

  render() {
    const gifts = this.props.gifts.gifts;
    let { apiError } = this.state;

    const user = this.getUser();

    const allFetched =
      this.props.gifts.isFetched &&
      this.props.userDetails.isFetched &&
      this.props.mainProduct.isFetched;

    if (user.isLoggedIn && !allFetched) {
      return (
        <MarketingBlock align="top" ratio="4to6" aside={<Banner/>}>
          <span className="ea-loading" aria-label="ladataan" tabIndex="0" />
        </MarketingBlock>
      );
    }

    const mainProduct = this.props.mainProduct.noProduct ? null : this.props.mainProduct;

    let totalPrice = 'xxx';
    if (mainProduct) {
      totalPrice = priceToFloat(mainProduct.price);
      totalPrice *= 24;
      totalPrice = totalPrice.toFixed(2).replace('.', ',');
    }

    const selectedGift = _.find(gifts, { productId: this.state.selectedGift } );

    // Separate gifts into public and reseller only
    const publicGifts = gifts.filter(gift => !gift.resellerOnly );
    const sellerGifts = gifts.filter(gift => gift.resellerOnly );

    // Enable confirm button when user has filled all the fields
    let buttonEnabled = this.state.selectedGift &&
      (!this.state.isDeviceRequiredForGift || this.state.selectedDeviceId) &&
      (this.state.pinCodeEntered || user.isImpersonated);

    if (this.state.delivery === 'other' && !this.state.otherEmail) {
      buttonEnabled = false;
    }

    if (this.state.page === 'thanks' && !_.isEmpty(this.props.submitData)) {
      const { customerId, productInfoAndPaymentDetails: productDetails } = this.props.submitData;

      if (customerId) {
        user.customerId = customerId;
      }

      let delivery = user.email;
      switch (this.state.delivery) {
        case 'post':
          delivery =
            user.address.street + ', ' +
            user.address.zipCode + ' ' +
            user.address.city;
          break;

        case 'otherEmail':
          delivery = this.state.otherEmail;
          break;
      }

      return <Thanks user={user} productDetails={productDetails} delivery={delivery}/>;
    }

    const eligible = apiError !== 'NOT_ELIGIBLE';
    const noContract = user.isLoggedIn && mainProduct === null || apiError === 'CONTRACT_NOT_FOUND';
    const hasContract = user.isLoggedIn && mainProduct !== null && apiError !== 'CONTRACT_NOT_FOUND';
    const notEligible = hasContract && !eligible;
    const isEligible = hasContract && eligible;
    const isDeviceRequiredForGift = this.state.isDeviceRequiredForGift;
    const selectedDeviceId = this.state.selectedDeviceId;
    const devices = user.devices && user.devices.map(device => {
      return {...device, name: !device.model.unknownDevice ? `${device.model.name} (${device.mac})` : device.mac};
    });
    const selectedDevice = isDeviceRequiredForGift ? _.find(devices, { id: selectedDeviceId } ) : undefined;
    return (
      <MarketingBlock align="top" ratio="4to6" aside={<Banner/>}>

        { !user.isLoggedIn && <div><ScrollToTop/><NotLoggedIn/></div> }

        { noContract && <div><ScrollToTop/><NoContract/></div> }

        { notEligible && <div><ScrollToTop/><NotEligible/></div> }

        { isEligible &&
        <div>
          <Blurb totalPrice={totalPrice}/>

          <GiftChooser
            gifts={publicGifts}
            selectedGift={this.state.selectedGift}
            updateForm={this.updateForm}/>
          {
            this.state.showUnderCounterGifts &&
            user.isImpersonated &&
            <GiftChooser gifts={sellerGifts}
                         type="undercounter"
                         title="Tiskinaluset"
                         selectedGift={this.state.selectedGift}
                         updateForm={this.updateForm}/>
          }

          <DeviceChooser
            devices={devices}
            selectedDeviceId={selectedDeviceId}
            updateForm={this.updateForm}
            isDeviceRequiredForGift={isDeviceRequiredForGift}/>

          <Summary product={mainProduct} selectedGift={selectedGift} selectedDevice={selectedDevice}/>

          <Form user={user} mainProduct={mainProduct} pinCode={this.state.pinCode} updateForm={this.updateForm}/>

          {this.state.errorMessage &&
            <div className="ea-notification ea-notification--error" style={{ margin: '1rem 0 1rem 0' }}>
              { this.state.errorMessage }
            </div>
          }

          <Button type="button" isLoading={this.state.isLoading} disabled={!buttonEnabled} onClick={this.confirmForm}>
            Vahvista
          </Button>
        </div>
        }

      </MarketingBlock>
    );
  }
}

const stateMap = state => ({
  user: state.user,
  userDetails: state.userDetails,
  gifts: state.rex.gifts,
  mainProduct: state.omaviihde,
  submitData: state.rex.submitData,
  apiError: state.rex.error
});

const dispatchMap = dispatch => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
  orderGifts: (data) => dispatch(orderGifts(data)),
  resetErrors: (data) => dispatch(resetErrors(data)),
  getUserData: (user) => {
    dispatch(getCurrentUserDetails(user));
    dispatch(getMainProduct());
    dispatch(getRexGifts());
    //  setTimeout(() => dispatch(getMainProduct()), 3000);
  },
  resetUserData: () => {
    dispatch(resetUserDetails());
    dispatch(resetMainProduct());
    dispatch(resetGifts());
  }
});

const RexContainer = connect(stateMap, dispatchMap)(Rex);
export default RexContainer;



// WEBPACK FOOTER //
// ./web/js/components/rex/Rex.js